import { useContext } from 'react';
import { ConfigContext } from '@common/Config';
import TranslationsContext from '../context';
import { isShowTranslationKeysRequested } from '../helpers';

export function useTranslations() {
    const { translations } = useContext(TranslationsContext);
    const config = useContext(ConfigContext);

    if (isShowTranslationKeysRequested(config)) {
        return {};
    }

    if (translations && Object.keys(translations).length > 0) {
        return translations;
    }

    if (typeof App !== 'undefined' && App.Translations && App.Translations.dictionary) {
        return App.Translations.dictionary[App.Config.language];
    }

    return {};
}
